export default "__VITE_ASSET__13ed5414__"